import { css } from '@emotion/css';
import {
  m,
  mobileMediaQuery,
  MotifComponent,
  nonMobileMediaQuery,
  smallDesktopMediaQuery,
} from '@snapchat/snap-design-system-marketing';

/** Snap.com home page specific footer bar wrapper styles */
export const footerBarWrapperCss = css`
  border: none;
  text-transform: uppercase;

  && {
    font-weight: 500;
  }
`;

/** Snap.com home page specific footer bar styles */
export const footerBarCss = css`
  /* Allow text to wrap on mobile to prevent screen overflow for locales with long names (e.g. German) */
  ${mobileMediaQuery} {
    & > ul > li > a {
      white-space: normal;
    }
  }

  ${nonMobileMediaQuery} {
    flex-wrap: wrap;
    gap: ${m('--spacing-l')};
    justify-content: start;
    padding-block: 20px;
    padding-inline: ${m('--spacing-xl')};

    /* Push the language selector to the right */
    & > div:last-child {
      margin-inline-start: auto;
    }

    /* Allow the groups of links to wrap to prevent screen overflow for locales with long names (e.g. German) */
    & > div > ul {
      flex-wrap: wrap;
    }
  }

  ${smallDesktopMediaQuery} {
    padding-inline: ${m('--spacing-xxxxl')};
  }

  label {
    font-weight: 500;

    /** Hide "Language" label on mobile */
    ${mobileMediaQuery} {
      display: none;
    }
  }

  &::after {
    background-color: black;
    content: '';
    height: 1px;
    left: ${m('--spacing-xl')}; /* Start 25% from the left */
    position: absolute;
    top: 0;
    width: calc(100% - ${m('--spacing-xxxxl')});

    ${smallDesktopMediaQuery} {
      left: 64px;
      width: calc(100% - 128px);
    }

    ${mobileMediaQuery} {
      left: 0;
      width: 100%;
    }
  }
`;

export const customHeaderCss = css`
  /**
   * Hide the header item indicator on the snap.com home page header item hover state
   */
  &:hover span::after {
    display: none;
  }

  /**
   * Override motif styles for IconButton used in snap.com home page Header to match design specs
   */
  && button.${MotifComponent.ICON_BUTTON} {
    border: none;
    box-shadow: none;
    padding: 0;
    margin-left: -10px;
    margin-right: 10px;

    *[dir='rtl'] & {
      margin-left: 10px;
      margin-right: -10px;
    }
  }

  /**
   * Hide aside element in snap.com home page header
   */
  & aside {
    display: none;
  }

  /**
   * Snap.com home page specific styles for nav element inside the Global Header
   */
  & nav {
    gap: ${m('--spacing-m')};

    /**
     * Remove right margin from the last nav link on snap.com home page header
     */
    & a:last-child {
      margin-right: 0;
    }
  }
`;
